<template>
  <div class="h-screen overflow-hidden">
    <landing-page-title></landing-page-title>
    <div class="row middle-xs center-xs">
      <pl-input
        @keyup.native="error_msg = ''"
        @keyup.native.enter="enterStaging"
        placeholder="Staging Password"
        v-model="staging_password"
        :errorMessage="error_msg"
        style="min-width: 341.55px"
        type="password"
      />
      <pl-button @click.native="enterStaging"> enter </pl-button>
    </div>
  </div>
</template>

<script lang="babel">
  export default {
    data() {
      return {
        error_msg: '',
        staging_password: '',
      };
    },
    components: {
      landingPageTitle: require('features/authentication/components/landingPageTitle.vue'),
    },
    props: [],
    methods: {
      enterStaging() {
        return this.staging_password === 'patties' ? this.$emit('acceptStaging') : this.error_msg = 'Wrong Password';
      },
    },
  };
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// stagingPassword.vue?2ea13c4e